import styled from 'styled-components';

const InputFields = styled.div`
  ${({ theme }) => theme.formInputFields};
`;

export default InputFields;
